import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { CommonService } from './common.service';
import { MainService } from './main.service';
import { Subject, Subscription, interval, ReplaySubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SsoService {
  interval:any;
  
  constructor(private _mainService: MainService, private router: Router, public alertController: AlertController, public _commonService: CommonService) { }

  getSSOURL(ssoId): Promise<any> {
    return this._mainService.callWebserviceHttpGet(`sso/URL/${ssoId}`, '');
  }

  checkUser(user,ssoId): Promise<any> {
    return this._mainService.callWebserviceHttpGet(`sso/Users/${user}?ssoId=${ssoId}`, '');
    //return this._mainService.callWebserviceHttpPatch()
  }

  getToken(ssoId, data): Promise<any> {
    return this._mainService.callWebserviceHttpPost(`sso/Login/${ssoId}`, data, '');
  }

  registration(ssoId, data): Promise<any> {
    return this._mainService.callWebserviceHttpPost(`sso/Registration/${ssoId}` , data, '');
  }

  async presentAlertConfirm(message) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: '',
      message: message,
      buttons: [ {
          text: this._commonService.getLocalTranslation('label-ok'),
          handler: () => {
            this.router.navigate(['/login']);
          }
        }
      ]
    });

    await alert.present();
  }

  getRefreshToken(): Promise<any> {
    return this._mainService.callWebserviceHttpGet(`sso/Token/${localStorage.authenticationKey}?ssoId=${localStorage.ssoId}`, '');
  }

  async refreshToken(){
    let source = interval(300000);
    setTimeout( async () => {
      if(localStorage.isSSO == 'true' && localStorage.authenticationKey) {
        let refreshToken = await this.getRefreshToken();
      }
    },3000);
    let sub = source.subscribe( async () => {
      try {
        if(localStorage.isSSO == 'true' && localStorage.authenticationKey) {
          let refreshToken = await this.getRefreshToken();
        }      
      } catch (error) {
      }
    })
  }
}
